// 샘플 검증 데이터 (비권한 사용자용 미리보기)
// eslint-disable-next-line
export const SAMPLE_VERIFICATION_RESULT = {
  "verdict": {
    "level": "warning",
    "summary": "전체 80개 항목 중 43건의 확인 사항이 있습니다.",
    "low_count": 7,
    "pass_rate": 39,
    "high_count": 34,
    "key_issues": [
      {
        "name": "보조기층",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "#40mm이하",
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "베이스판",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "100x100x2.3T",
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "L하스너",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "50x50x5T",
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "조경토",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": null,
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "주춧돌 기초",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "300*300*300mm",
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "흰색아나별수국",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "7치",
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "라벤다",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "5치",
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "빅베고니아",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "4치",
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "휴케라",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "이색포트",
        "description": "견적 단가를 사용 중인 자재입니다."
      },
      {
        "name": "동백나무(조형)",
        "guide": "2곳 이상의 견적서를 확인하세요.",
        "severity": "high",
        "standard": "H2.0×W1.5",
        "description": "견적 단가를 사용 중인 자재입니다."
      }
    ],
    "pass_count": 31,
    "medium_count": 20,
    "category_stats": {
      "labor_prices": {
        "low": 0,
        "high": 0,
        "pass": 0,
        "label": "노임단가",
        "total": 9,
        "medium": 9,
        "pass_rate": 0
      },
      "itemize_costs": {
        "low": 7,
        "high": 1,
        "pass": 24,
        "label": "일위대가",
        "total": 38,
        "medium": 6,
        "pass_rate": 63
      },
      "material_prices": {
        "low": 0,
        "high": 24,
        "pass": 4,
        "label": "자재단가",
        "total": 28,
        "medium": 0,
        "pass_rate": 14
      },
      "price_calculations": {
        "low": 0,
        "high": 2,
        "pass": 3,
        "label": "단가산출",
        "total": 5,
        "medium": 0,
        "pass_rate": 60
      }
    },
    "total_key_issues": 54,
    "weighted_pass_rate": 0
  },
  "action_items": [
    {
      "count": 24,
      "items": [
        {
          "name": "보조기층",
          "category": "자재단가",
          "standard": "#40mm이하"
        },
        {
          "name": "베이스판",
          "category": "자재단가",
          "standard": "100x100x2.3T"
        },
        {
          "name": "L하스너",
          "category": "자재단가",
          "standard": "50x50x5T"
        },
        {
          "name": "조경토",
          "category": "자재단가",
          "standard": null
        },
        {
          "name": "주춧돌 기초",
          "category": "자재단가",
          "standard": "300*300*300mm"
        },
        {
          "name": "흰색아나별수국",
          "category": "자재단가",
          "standard": "7치"
        },
        {
          "name": "라벤다",
          "category": "자재단가",
          "standard": "5치"
        },
        {
          "name": "빅베고니아",
          "category": "자재단가",
          "standard": "4치"
        },
        {
          "name": "휴케라",
          "category": "자재단가",
          "standard": "이색포트"
        },
        {
          "name": "동백나무(조형)",
          "category": "자재단가",
          "standard": "H2.0×W1.5"
        },
        {
          "name": "청사철",
          "category": "자재단가",
          "standard": "H1.3×W0.3"
        },
        {
          "name": "옥외용벤치",
          "category": "자재단가",
          "standard": "1800×380×730mm"
        },
        {
          "name": "삼색버드나무",
          "category": "자재단가",
          "standard": "H1.3×W1.0"
        },
        {
          "name": "합성목재데크",
          "category": "자재단가",
          "standard": "3000×150×25mm"
        },
        {
          "name": "고정핀",
          "category": "자재단가",
          "standard": "Φ10×330mm"
        },
        {
          "name": "보행매트",
          "category": "자재단가",
          "standard": "1000×t30mm"
        },
        {
          "name": "옥외용벤치",
          "category": "자재단가",
          "standard": "1600×445×415mm"
        },
        {
          "name": "스텐레스볼라드",
          "category": "자재단가",
          "standard": "SUS304, H=1000"
        },
        {
          "name": "안전표지판",
          "category": "자재단가",
          "standard": "600x900, 반사형"
        },
        {
          "name": "탄성포장재",
          "category": "자재단가",
          "standard": "EPDM, t=13mm"
        },
        {
          "name": "조경석",
          "category": "자재단가",
          "standard": "자연석, 0.5ton"
        },
        {
          "name": "무가재료",
          "category": "자재단가",
          "standard": "시험용"
        },
        {
          "name": "특수자재A",
          "category": "자재단가",
          "standard": ""
        },
        {
          "name": "관급부대비용",
          "category": "자재단가",
          "standard": ""
        }
      ],
      "title": "비교견적서 제출 요청",
      "priority": "required",
      "template": "검토 결과, 아래 항목은 공인 가격정보(물가자료, 조달청 등)에 등록되지 않은 견적 단가를 사용하고 있습니다. 「국가를 당사자로 하는 계약에 관한 법률 시행규칙」 제7조에 따라 2곳 이상의 비교견적서를 징구하여 적정 가격 여부를 확인하시기 바랍니다."
    },
    {
      "count": 4,
      "items": [
        {
          "name": "성토면고르기",
          "category": "단가산출",
          "standard": "굴삭기 0.2㎡"
        },
        {
          "name": "보조기층운반",
          "category": "단가산출",
          "standard": "덤프트럭15톤"
        },
        {
          "name": "휴케라식재",
          "category": "일위대가",
          "standard": null
        },
        {
          "name": "청사철식재",
          "category": "일위대가",
          "standard": "H1.3×W1.0"
        }
      ],
      "title": "산출근거 자료 제출 요청",
      "priority": "required",
      "template": "아래 항목은 표준품셈에 등록되지 않은 비표준 단가로, 설계자가 직접 작성한 산출내역입니다. 적정성 검증을 위해 산출근거 자료(계산서, 참고문헌, 유사 실적 등)를 제출받아 확인하시기 바랍니다."
    },
    {
      "count": 4,
      "items": [
        {
          "name": "옥외용벤치",
          "detail": "인도조건 \"현장설치도\" → 관급자관급이어야 하나 도급자관급에 배치됨",
          "category": "관급자재",
          "standard": "1600×445×415mm"
        },
        {
          "name": "조경석",
          "detail": "인도조건 \"현장설치도\" → 관급자관급이어야 하나 도급자관급에 배치됨",
          "category": "관급자재",
          "standard": "자연석, 0.5ton"
        },
        {
          "name": "합성목재데크",
          "detail": "인도조건 \"납품장소 하차도\" → 도급자관급이어야 하나 관급자관급에 배치됨",
          "category": "관급자재",
          "standard": "3000×150×25mm"
        },
        {
          "name": "보행매트",
          "detail": "인도조건 \"납품장소 하차도\" → 도급자관급이어야 하나 관급자관급에 배치됨",
          "category": "관급자재",
          "standard": "W=1200"
        }
      ],
      "title": "관급자재 분류 재배치 요청",
      "priority": "required",
      "template": "아래 관급자재는 물품인도조건에 따른 분류가 올바르지 않습니다. 현장설치도 품목은 관급자관급, 납품장소 하차도 품목은 도급자관급으로 분류되어야 합니다. 조달청 나라장터에서 인도조건을 확인 후 재배치를 요청하시기 바랍니다."
    },
    {
      "count": 7,
      "items": [
        {
          "name": "합성목재데크",
          "detail": "적용단가(0원)와 조달 계약단가(120,000원) 차이 120,000원",
          "category": "관급자재",
          "standard": "3000×150×25mm"
        },
        {
          "name": "고정핀",
          "detail": "물품식별번호 12345678에 해당하는 조달단가가 없습니다.",
          "category": "관급자재",
          "standard": "Φ10×330mm"
        },
        {
          "name": "보행매트",
          "detail": "적용단가(0원)와 조달 계약단가(1,150원) 차이 1,150원",
          "category": "관급자재",
          "standard": "1000×t30mm"
        },
        {
          "name": "스텐레스볼라드",
          "detail": "비고란에 물품식별번호(8자리)를 확인하세요.",
          "category": "관급자재",
          "standard": "SUS304, H=1000"
        },
        {
          "name": "안전표지판",
          "detail": "비고란에 물품식별번호(8자리)를 확인하세요.",
          "category": "관급자재",
          "standard": "600x900, 반사형"
        },
        {
          "name": "무가재료",
          "detail": "적용단가(0원)와 조달 계약단가(1,150원) 차이 1,150원",
          "category": "관급자재",
          "standard": "시험용"
        },
        {
          "name": "특수자재A",
          "detail": "비고란에 물품식별번호(8자리)를 확인하세요.",
          "category": "관급자재",
          "standard": ""
        }
      ],
      "title": "관급자재 단가 확인 요청",
      "priority": "required",
      "template": "아래 관급자재는 조달청 계약단가와 적용단가에 차이가 있거나, 물품식별번호 확인이 필요한 항목입니다. 조달청 나라장터에서 최신 계약단가를 조회하여 확인하시기 바랍니다."
    },
    {
      "count": 9,
      "items": [
        {
          "name": "보통인부",
          "category": "노임단가",
          "standard": ""
        },
        {
          "name": "철    공",
          "category": "노임단가",
          "standard": ""
        },
        {
          "name": "용 접 공(일반)",
          "category": "노임단가",
          "standard": ""
        },
        {
          "name": "포 설 공",
          "category": "노임단가",
          "standard": ""
        },
        {
          "name": "건축목공",
          "category": "노임단가",
          "standard": ""
        },
        {
          "name": "조 경 공",
          "category": "노임단가",
          "standard": ""
        },
        {
          "name": "건설기계운전사",
          "category": "노임단가",
          "standard": ""
        },
        {
          "name": "화물차운전사",
          "category": "노임단가",
          "standard": ""
        },
        {
          "name": "일반기계운전사",
          "category": "노임단가",
          "standard": ""
        }
      ],
      "title": "노임단가 확인 요청",
      "priority": "review",
      "template": "아래 노임단가는 대한건설협회 시중노임단가와 차이가 있거나 출처 확인이 필요한 항목입니다. 최신 시중노임단가 적용 여부를 확인하시기 바랍니다."
    },
    {
      "count": 6,
      "items": [
        {
          "name": "흰색아나별수국식재",
          "category": "일위대가",
          "standard": null
        },
        {
          "name": "라벤다식재",
          "category": "일위대가",
          "standard": null
        },
        {
          "name": "빅베고니아식재",
          "category": "일위대가",
          "standard": null
        },
        {
          "name": "동백나무식재",
          "category": "일위대가",
          "standard": "H2.0×W1.5"
        },
        {
          "name": "삼색버드나무식재",
          "category": "일위대가",
          "standard": "H1.3×W1.0"
        },
        {
          "name": "이윤 절사 조정",
          "detail": "이윤에서 1,039원이 절사 조정되었습니다. (1,000원 단위)",
          "category": "프로젝트 설정",
          "standard": ""
        }
      ],
      "title": "가격 변경 근거 확인 요청",
      "priority": "review",
      "template": "아래 항목은 공인 기준데이터 대비 가격 변경이 확인된 항목입니다. 단가 변경 사유 및 근거자료를 확인하시기 바랍니다."
    },
    {
      "count": 7,
      "items": [
        {
          "name": "먼나무이식",
          "category": "일위대가",
          "standard": "H4"
        },
        {
          "name": "동백나무이식",
          "category": "일위대가",
          "standard": "H2"
        },
        {
          "name": "홍가시나무이식",
          "category": "일위대가",
          "standard": "H1.5"
        },
        {
          "name": "벗나무이식",
          "category": "일위대가",
          "standard": "H5"
        },
        {
          "name": "치자나무이식",
          "category": "일위대가",
          "standard": "H0.4"
        },
        {
          "name": "수국이식",
          "category": "일위대가",
          "standard": "H0.3"
        },
        {
          "name": "백일홍식재",
          "category": "일위대가",
          "standard": null
        }
      ],
      "title": "변경 사항 확인",
      "priority": "info",
      "template": "아래 항목은 표준품셈 기준데이터에서 일부 변경이 확인된 항목입니다. 필요시 변경 사유를 확인하시기 바랍니다."
    }
  ],
  "labor_prices": [
    {
      "id": 2,
      "name": "보통인부",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 172068,
          "file_value": 171037,
          "impact_amount": -1031
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 169804,
          "file_value": 171037,
          "impact_amount": 1233
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 171037,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    },
    {
      "id": 9,
      "name": "철    공",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 239808,
          "file_value": 237686,
          "impact_amount": -2122
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 237754,
          "file_value": 237686,
          "impact_amount": -68
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 237686,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    },
    {
      "id": 13,
      "name": "용 접 공(일반)",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 282536,
          "file_value": 280178,
          "impact_amount": -2358
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 278326,
          "file_value": 280178,
          "impact_amount": 1852
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 280178,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    },
    {
      "id": 20,
      "name": "포 설 공",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 221015,
          "file_value": 219579,
          "impact_amount": -1436
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 216121,
          "file_value": 219579,
          "impact_amount": 3458
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 219579,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    },
    {
      "id": 25,
      "name": "건축목공",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 277642,
          "file_value": 283068,
          "impact_amount": 5426
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 277894,
          "file_value": 283068,
          "impact_amount": 5174
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 283068,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    },
    {
      "id": 40,
      "name": "조 경 공",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 235204,
          "file_value": 227176,
          "impact_amount": -8028
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 224132,
          "file_value": 227176,
          "impact_amount": 3044
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 227176,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    },
    {
      "id": 51,
      "name": "건설기계운전사",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 283297,
          "file_value": 279824,
          "impact_amount": -3473
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 273971,
          "file_value": 279824,
          "impact_amount": 5853
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 279824,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    },
    {
      "id": 53,
      "name": "화물차운전사",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 238936,
          "file_value": 240685,
          "impact_amount": 1749
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 237500,
          "file_value": 240685,
          "impact_amount": 3185
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 240685,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    },
    {
      "id": 55,
      "name": "일반기계운전사",
      "guide": "최신 노임단가를 적용했는지 확인하세요.",
      "reason": "적용일자 불일치",
      "status": "needs_review",
      "changes": [
        {
          "field": "적용일자",
          "original": "2026-01-01",
          "file_value": "2025-12-30"
        },
        {
          "field": "최저단가 단가",
          "original": 173995,
          "file_value": 172387,
          "impact_amount": -1608
        },
        {
          "field": "적용단가 (DB 기준단가와 불일치)",
          "original": 170920,
          "file_value": 172387,
          "impact_amount": 1467
        }
      ],
      "severity": "medium",
      "standard": "",
      "applyPrice": 172387,
      "description": "노임단가 적용일자가 최신 시중노임단가와 다릅니다."
    }
  ],
  "project_name": "샘플 프로젝트",
  "project_type": "normal",
  "itemize_costs": [
    {
      "id": 108837,
      "name": "벌개제근 / 뿌리뽑기 ",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "입목 본수도 50-60%, 수경 10∼20cm이하, 집재거리 L=100m 까지",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 110102,
      "name": "보조기층 / 인력식 소규모장비 포설",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "t=20cm",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 110749,
      "name": "교목 굴취 / 나무높이 / 기계시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "5.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 110767,
      "name": "교목 식재 / 나무높이 / 기계시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "5.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120436,
      "name": "먼나무이식",
      "note": "재조합 기본데이터",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "low",
      "standard": "H4",
      "description": "표준품셈 기준데이터로 구성된 일위대가입니다."
    },
    {
      "id": 110744,
      "name": "교목 굴취 / 나무높이 / 인력시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "2.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 110762,
      "name": "교목 식재 / 나무높이 / 인력시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "2.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120437,
      "name": "동백나무이식",
      "note": "재조합 기본데이터",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "low",
      "standard": "H2",
      "description": "표준품셈 기준데이터로 구성된 일위대가입니다."
    },
    {
      "id": 110744,
      "name": "교목 굴취 / 나무높이 / 인력시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "2.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 110762,
      "name": "교목 식재 / 나무높이 / 인력시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "2.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120438,
      "name": "홍가시나무이식",
      "note": "재조합 기본데이터",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "low",
      "standard": "H1.5",
      "description": "표준품셈 기준데이터로 구성된 일위대가입니다."
    },
    {
      "id": 110749,
      "name": "교목 굴취 / 나무높이 / 기계시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "5.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 110767,
      "name": "교목 식재 / 나무높이 / 기계시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "5.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120439,
      "name": "벗나무이식",
      "note": "재조합 기본데이터",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "low",
      "standard": "H5",
      "description": "표준품셈 기준데이터로 구성된 일위대가입니다."
    },
    {
      "id": 110801,
      "name": "관목 굴취 / 나무높이",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "0.3~0.7m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 110805,
      "name": "관목 식재(단식) / 나무높이",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "0.3~0.7m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120440,
      "name": "치자나무이식",
      "note": "재조합 기본데이터",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "low",
      "standard": "H0.4",
      "description": "표준품셈 기준데이터로 구성된 일위대가입니다."
    },
    {
      "id": 110801,
      "name": "관목 굴취 / 나무높이",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "0.3~0.7m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 110805,
      "name": "관목 식재(단식) / 나무높이",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "0.3~0.7m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120441,
      "name": "수국이식",
      "note": "재조합 기본데이터",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "low",
      "standard": "H0.3",
      "description": "표준품셈 기준데이터로 구성된 일위대가입니다."
    },
    {
      "id": 110804,
      "name": "관목 식재(단식) / 나무높이",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "0.3m 미만",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120442,
      "name": "흰색아나별수국식재",
      "guide": "불일치 항목을 개별 확인하세요.",
      "reason": "부분 통과",
      "status": "needs_review",
      "changes": [],
      "severity": "medium",
      "standard": null,
      "description": "일부 구성 항목만 표준품셈과 일치합니다.",
      "content_checks": [
        {
          "name": "흰색아나별수국",
          "type": "자재",
          "detail": "다른 사용자 데이터",
          "ref_id": 214633,
          "result": "확인 필요"
        },
        {
          "name": "관목 식재(단식) / 나무높이",
          "type": "일위대가",
          "detail": "기본데이터",
          "ref_id": 110804,
          "result": "통과"
        }
      ]
    },
    {
      "id": 110812,
      "name": "초화류 식재",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "양호",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120443,
      "name": "라벤다식재",
      "guide": "불일치 항목을 개별 확인하세요.",
      "reason": "부분 통과",
      "status": "needs_review",
      "changes": [],
      "severity": "medium",
      "standard": null,
      "description": "일부 구성 항목만 표준품셈과 일치합니다.",
      "content_checks": [
        {
          "name": "라벤다",
          "type": "자재",
          "detail": "다른 사용자 데이터",
          "ref_id": 214634,
          "result": "확인 필요"
        },
        {
          "name": "초화류 식재",
          "type": "일위대가",
          "detail": "기본데이터",
          "ref_id": 110812,
          "result": "통과"
        }
      ]
    },
    {
      "id": 110812,
      "name": "초화류 식재",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "양호",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120444,
      "name": "백일홍식재",
      "note": "재조합 기본데이터",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "low",
      "standard": null,
      "description": "표준품셈 기준데이터로 구성된 일위대가입니다."
    },
    {
      "id": 110812,
      "name": "초화류 식재",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "양호",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120445,
      "name": "빅베고니아식재",
      "guide": "불일치 항목을 개별 확인하세요.",
      "reason": "부분 통과",
      "status": "needs_review",
      "changes": [],
      "severity": "medium",
      "standard": null,
      "description": "일부 구성 항목만 표준품셈과 일치합니다.",
      "content_checks": [
        {
          "name": "빅베고니아",
          "type": "자재",
          "detail": "다른 사용자 데이터",
          "ref_id": 214636,
          "result": "확인 필요"
        },
        {
          "name": "초화류 식재",
          "type": "일위대가",
          "detail": "기본데이터",
          "ref_id": 110812,
          "result": "통과"
        }
      ]
    },
    {
      "id": 110812,
      "name": "초화류 식재",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "양호",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120446,
      "name": "휴케라식재",
      "guide": "산출 근거 자료를 요청하세요.",
      "reason": "DB에 없는 일위대가",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": null,
      "description": "표준품셈에 등록되지 않은 일위대가입니다. 설계자가 직접 작성했습니다."
    },
    {
      "id": 110762,
      "name": "교목 식재 / 나무높이 / 인력시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "2.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120452,
      "name": "동백나무식재",
      "guide": "불일치 항목을 개별 확인하세요.",
      "reason": "부분 통과",
      "status": "needs_review",
      "changes": [],
      "severity": "medium",
      "standard": "H2.0×W1.5",
      "description": "일부 구성 항목만 표준품셈과 일치합니다.",
      "content_checks": [
        {
          "name": "동백나무(조형)",
          "type": "자재",
          "detail": "다른 사용자 데이터",
          "ref_id": 214650,
          "result": "확인 필요"
        },
        {
          "name": "교목 식재 / 나무높이 / 인력시공",
          "type": "일위대가",
          "detail": "기본데이터",
          "ref_id": 110762,
          "result": "통과"
        }
      ]
    },
    {
      "id": 120453,
      "name": "청사철식재",
      "guide": "각 구성 항목의 출처를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "medium",
      "standard": "H1.3×W1.0",
      "description": "모든 구성 항목이 표준품셈에 없는 비표준 데이터입니다."
    },
    {
      "id": 110762,
      "name": "교목 식재 / 나무높이 / 인력시공",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "2.0m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 120455,
      "name": "삼색버드나무식재",
      "guide": "불일치 항목을 개별 확인하세요.",
      "reason": "부분 통과",
      "status": "needs_review",
      "changes": [],
      "severity": "medium",
      "standard": "H1.3×W1.0",
      "description": "일부 구성 항목만 표준품셈과 일치합니다.",
      "content_checks": [
        {
          "name": "삼색버드나무",
          "type": "자재",
          "detail": "다른 사용자 데이터",
          "ref_id": 214653,
          "result": "확인 필요"
        },
        {
          "name": "교목 식재 / 나무높이 / 인력시공",
          "type": "일위대가",
          "detail": "기본데이터",
          "ref_id": 110762,
          "result": "통과"
        }
      ]
    },
    {
      "id": 110825,
      "name": "야자섬유매트포장",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "폭 1.5m 이하",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 111911,
      "name": "목재데크틀 설치",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "평구조",
      "description": "품셈 기준데이터와 일치합니다."
    },
    {
      "id": 111909,
      "name": "목재데크 설치",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "주재료비 별도",
      "description": "품셈 기준데이터와 일치합니다."
    }
  ],
  "material_prices": [
    {
      "id": 157327,
      "name": "경    유",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "division": "일반",
      "severity": "none",
      "standard": "저 유 황",
      "applyPrice": 1273,
      "description": "품셈 기준데이터와 일치합니다.",
      "is_government": false
    },
    {
      "id": 55926,
      "name": "보조기층",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "#40mm이하",
      "applyPrice": 36000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 60331,
      "name": "베이스판",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "100x100x2.3T",
      "applyPrice": 22000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 63959,
      "name": "L하스너",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "50x50x5T",
      "applyPrice": 1500,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 153181,
      "name": "조경토",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": null,
      "applyPrice": 15000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 163253,
      "name": "구조용각관(백관,아연도)",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "division": "일반",
      "severity": "none",
      "standard": "50*50*2.3t",
      "applyPrice": 4710,
      "description": "품셈 기준데이터와 일치합니다.",
      "is_government": false
    },
    {
      "id": 168151,
      "name": "셋트앵커(STS)",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "division": "일반",
      "severity": "none",
      "standard": "Ø1/2\"  길이100mm",
      "applyPrice": 2100,
      "description": "품셈 기준데이터와 일치합니다.",
      "is_government": false
    },
    {
      "id": 172460,
      "name": "직결나사(S.D.S)",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "division": "일반",
      "severity": "none",
      "standard": "#14 *ø6mm*60mm",
      "applyPrice": 60,
      "description": "품셈 기준데이터와 일치합니다.",
      "is_government": false
    },
    {
      "id": 174877,
      "name": "주춧돌 기초",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "300*300*300mm",
      "applyPrice": 32000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214633,
      "name": "흰색아나별수국",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "7치",
      "applyPrice": 40000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214634,
      "name": "라벤다",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "5치",
      "applyPrice": 10000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214636,
      "name": "빅베고니아",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "4치",
      "applyPrice": 1000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214637,
      "name": "휴케라",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "DB에 없는 자재",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "이색포트",
      "applyPrice": 7000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214650,
      "name": "동백나무(조형)",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "H2.0×W1.5",
      "applyPrice": 450000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214651,
      "name": "청사철",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "H1.3×W0.3",
      "applyPrice": 6000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214652,
      "name": "옥외용벤치",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "1800×380×730mm",
      "applyPrice": 350000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214653,
      "name": "삼색버드나무",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "H1.3×W1.0",
      "applyPrice": 70000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    },
    {
      "id": 214638,
      "name": "합성목재데크",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "3000×150×25mm",
      "applyPrice": 102800,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "납품장소 하차도",
      "government_category": "관급자관급"
    },
    {
      "id": 214639,
      "name": "고정핀",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "Φ10×330mm",
      "applyPrice": 800,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "",
      "government_category": "도급자관급"
    },
    {
      "id": 214640,
      "name": "보행매트",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "1000×t30mm",
      "applyPrice": 23000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "납품장소 하차도",
      "government_category": "관급자관급"
    },
    {
      "id": 214654,
      "name": "옥외용벤치",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "사용자 생성 데이터",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "1600×445×415mm",
      "applyPrice": 322000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "현장설치도",
      "government_category": "도급자관급"
    },
    {
      "id": 300001,
      "name": "스텐레스볼라드",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "DB에 없는 자재",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "SUS304, H=1000",
      "applyPrice": 250000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "",
      "government_category": "도급자관급"
    },
    {
      "id": 300002,
      "name": "안전표지판",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "DB에 없는 자재",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "600x900, 반사형",
      "applyPrice": 45000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "",
      "government_category": "도급자관급"
    },
    {
      "id": 300003,
      "name": "탄성포장재",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "DB에 없는 자재",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "EPDM, t=13mm",
      "applyPrice": 120000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "납품장소 하차도",
      "government_category": "도급자관급"
    },
    {
      "id": 300004,
      "name": "조경석",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "DB에 없는 자재",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "자연석, 0.5ton",
      "applyPrice": 85000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "현장설치도",
      "government_category": "도급자관급"
    },
    {
      "id": 300005,
      "name": "무가재료",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "DB에 없는 자재",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "시험용",
      "applyPrice": 0,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "납품장소 하차도",
      "government_category": "도급자관급"
    },
    {
      "id": 300006,
      "name": "특수자재A",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "DB에 없는 자재",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "",
      "applyPrice": 500000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": true,
      "delivery_condition": "",
      "government_category": "도급자관급"
    },
    {
      "id": -100,
      "name": "관급부대비용",
      "guide": "2곳 이상의 견적서를 확인하세요.",
      "reason": "DB에 없는 자재",
      "status": "needs_review",
      "changes": [],
      "severity": "high",
      "standard": "",
      "applyPrice": 30000,
      "description": "견적 단가를 사용 중인 자재입니다.",
      "is_government": false
    }
  ],
  "project_settings": {
    "rates": [
      {
        "name": "간접노무비",
        "rate": 16.2,
        "array": "laborInvoices",
        "letter": "F2",
        "apply_date": "2025-04-01"
      },
      {
        "name": "간접재료비",
        "rate": 0,
        "array": "materialInvoices",
        "letter": "E3"
      },
      {
        "name": "산재보험료",
        "rate": 3.56,
        "array": "expenseInvoices",
        "letter": "G2",
        "apply_date": "2026-01-01"
      },
      {
        "name": "고용보험료",
        "rate": 1.01,
        "array": "expenseInvoices",
        "letter": "G3"
      },
      {
        "name": "건설기계대여대금",
        "rate": 0.16,
        "array": "expenseInvoices",
        "letter": "G7"
      },
      {
        "name": "산업안전관리비",
        "rate": 3.15,
        "array": "expenseInvoices",
        "letter": "G9"
      },
      {
        "name": "환경보전비",
        "rate": 0.3,
        "array": "expenseInvoices",
        "letter": "G10"
      },
      {
        "name": "공사이행보증수수료",
        "rate": 0,
        "array": "expenseInvoices",
        "letter": "G12"
      },
      {
        "name": "건설하도급대금지급보증서발급수수료",
        "rate": 0,
        "array": "expenseInvoices",
        "letter": "G13"
      },
      {
        "name": "기타경비",
        "rate": 4.6,
        "array": "expenseInvoices",
        "letter": "G14",
        "apply_date": "2025-04-01"
      },
      {
        "name": "이윤",
        "rate": 15,
        "array": "beforeVatInvoices",
        "letter": "I1"
      },
      {
        "name": "일반관리비",
        "rate": 8,
        "array": "generalInvoice",
        "letter": "H2"
      }
    ],
    "issues": [
      {
        "guide": "절사 금액과 근거를 확인하세요.",
        "title": "이윤 절사 조정",
        "severity": "medium",
        "description": "이윤에서 1,039원이 절사 조정되었습니다. (1,000원 단위)"
      }
    ],
    "cutting": {
      "adjusted_items": [
        {
          "title": "이윤",
          "letter": "I1",
          "category": "절사 조정",
          "cutting_expr": "-1143/1.1",
          "cutting_amount": 1039
        }
      ],
      "do_cutting_unit": 1000,
      "do_cutting_amount": 1039
    },
    "flag_calculated": false,
    "labor_surcharge": {
      "rate": 0,
      "enabled": false,
      "apply_date": "2025-12-30",
      "total_count": 62,
      "applied_count": 0,
      "db_apply_date": "2026-01-01"
    },
    "rate_apply_dates": {
      "기타경비": "2025-04-01",
      "간접노무비": "2025-04-01",
      "건강보험료": "2026-01-01",
      "산재보험료": "2026-01-01",
      "연금보험료": "2026-01-01",
      "노인장기요양보험료": "2026-01-01",
      "산업안전보건관리비": "2025-01-01"
    },
    "construction_info": {
      "type": "landscape",
      "duration": 29,
      "settings": [
        {
          "label": "건설기계대여금",
          "value": "조경시설물·조경식재·도장·철도궤도·철강재설치"
        },
        {
          "label": "건설업 종류",
          "value": "전문건설업"
        },
        {
          "label": "산업안전보건관리비",
          "value": "토목공사"
        },
        {
          "label": "환경보전비",
          "value": "조경/기타"
        }
      ],
      "type_label": "조경공사"
    },
    "standard_rate_ranges": {
      "이윤": {
        "max": 15.0,
        "min": 9.0
      },
      "기타경비": {
        "max": 10.3,
        "min": 4.6
      },
      "간접노무비": {
        "max": 17.7,
        "min": 10.1
      },
      "일반관리비": {
        "max": 8.0,
        "min": 4.5
      },
      "퇴직공제부금비": {
        "max": 2.3,
        "min": 2.3
      }
    }
  },
  "price_calculations": [
    {
      "id": 213,
      "name": "잔토처리(현장내)",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "백호0.2㎥(100%)",
      "description": "품셈 기준데이터와 일치합니다.",
      "machine_checks": [
        {
          "machine_id": 38,
          "machine_name": "굴삭기(무한궤도)",
          "subtitle_name": "굴삭기(무한궤도)",
          "template_name": "굴삭기(무한궤도)",
          "calc_method_ok": true,
          "overall_status": "match",
          "template_found": true,
          "variable_checks": [
            {
              "name": "K",
              "label": "버킷계수",
              "status": "match",
              "explain": "0.9",
              "file_value": 0.9,
              "variable_type": "condition_select",
              "condition_name": "약간 단단한 토질",
              "condition_value": 0.9
            },
            {
              "name": "f",
              "label": "체적변화율(1/L)",
              "status": "formula_derived",
              "explain": "1/1.24",
              "file_value": 0.81,
              "closest_value": 0.8,
              "variable_type": "condition_select",
              "condition_name": "점토 범위 조건",
              "formula_context": {
                "L": 1.24,
                "type": "1/L",
                "soil_found": true,
                "description": "1 / 토량변화율(1.24) — 점토 범위, 표준 범위 1.20~1.45",
                "formula_label": "1 / 토량변화율(1.24)",
                "short_description": "점토 범위 조건"
              },
              "closest_condition": "점토(粘土)"
            },
            {
              "name": "E",
              "label": "작업효율",
              "status": "match",
              "explain": "(0.75+0.65)/2",
              "file_value": 0.7,
              "variable_type": "condition_select",
              "condition_name": "모래, 사질토 / 자연상태-보통",
              "condition_value": 0.7,
              "formula_context": {
                "type": "average",
                "soil_found": false,
                "description": "0.75(모래, 사질토 / 흐트러진상태-보통)과 0.65(자갈섞인흙, 점성토 / 흐트러진상태-보통)의 평균"
              }
            },
            {
              "name": "Cm",
              "label": "사이클타임",
              "status": "match",
              "explain": "15",
              "file_value": 15.0,
              "variable_type": "condition_select",
              "condition_name": "0.12~0.4 / 90도",
              "condition_value": 15.0
            }
          ]
        }
      ]
    },
    {
      "id": 265,
      "name": "성토",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "백호0.2㎥",
      "description": "품셈 기준데이터와 일치합니다.",
      "machine_checks": [
        {
          "machine_id": 38,
          "machine_name": "굴삭기(무한궤도)",
          "subtitle_name": "굴삭기(무한궤도)",
          "template_name": "굴삭기(무한궤도)",
          "calc_method_ok": true,
          "overall_status": "match",
          "template_found": true,
          "variable_checks": [
            {
              "name": "K",
              "label": "버킷계수",
              "status": "match",
              "explain": "1.1",
              "file_value": 1.1,
              "variable_type": "condition_select",
              "condition_name": "용이한 굴착(연한 토질, 산적)",
              "condition_value": 1.1
            },
            {
              "name": "f",
              "label": "체적변화율(1/L)",
              "status": "formula_derived",
              "explain": "0.98/1.24",
              "file_value": 0.79,
              "closest_value": 0.8,
              "variable_type": "condition_select",
              "condition_name": "점토 범위 조건",
              "formula_context": {
                "C": 0.98,
                "L": 1.24,
                "type": "C/L",
                "soil_found": true,
                "description": "다짐계수(0.98) / 토량변화율(1.24) — 점토 범위, 표준 범위 1.20~1.45",
                "formula_label": "다짐계수(0.98) / 토량변화율(1.24)",
                "short_description": "점토 범위 조건"
              },
              "closest_condition": "점토(粘土)"
            },
            {
              "name": "E",
              "label": "작업효율",
              "status": "match",
              "explain": "0.65",
              "file_value": 0.65,
              "variable_type": "condition_select",
              "condition_name": "자갈섞인흙, 점성토 / 흐트러진상태-보통",
              "condition_value": 0.65
            },
            {
              "name": "Cm",
              "label": "사이클타임",
              "status": "match",
              "explain": "18",
              "file_value": 18.0,
              "variable_type": "condition_select",
              "condition_name": "0.12~0.4 / 135도",
              "condition_value": 18.0
            }
          ]
        }
      ]
    },
    {
      "id": 250,
      "name": "성토면고르기",
      "guide": "해당 변수값이 현장 조건에 적합한지 검토하세요.",
      "status": "modified",
      "changes": [],
      "severity": "high",
      "standard": "굴삭기 0.2㎡",
      "description": "기계경비 변수가 조건표 범위를 벗어납니다.",
      "machine_checks": [
        {
          "machine_id": 38,
          "machine_name": "굴삭기(무한궤도)",
          "subtitle_name": "굴삭기(무한궤도)",
          "template_name": "굴삭기(무한궤도)",
          "calc_method_ok": false,
          "overall_status": "review_required",
          "template_found": true,
          "variable_checks": [
            {
              "name": "K",
              "label": "버킷계수",
              "status": "no_value",
              "file_value": null,
              "variable_type": "condition_select"
            },
            {
              "name": "f",
              "label": "체적변화율(1/L)",
              "status": "no_value",
              "file_value": null,
              "variable_type": "condition_select"
            },
            {
              "name": "E",
              "label": "작업효율",
              "status": "no_value",
              "file_value": null,
              "variable_type": "condition_select"
            },
            {
              "name": "Cm",
              "label": "사이클타임",
              "status": "no_value",
              "file_value": null,
              "variable_type": "condition_select"
            }
          ],
          "calc_method_issue": "Q 산출량 적용이 나누기→곱하기로 변경됨"
        }
      ]
    },
    {
      "id": 1149,
      "name": "순성토운반(토사)",
      "guide": "추가 확인이 필요하지 않습니다.",
      "status": "pass",
      "changes": [],
      "severity": "none",
      "standard": "덤프15톤 + 백호0.7㎥",
      "description": "품셈 기준데이터와 일치합니다.",
      "machine_checks": [
        {
          "machine_id": 47,
          "machine_name": "굴삭기(무한궤도)",
          "subtitle_name": "굴착 및 적재 : 굴삭기(무한궤도)",
          "template_name": "굴삭기(무한궤도)",
          "calc_method_ok": true,
          "overall_status": "match",
          "template_found": true,
          "variable_checks": [
            {
              "name": "K",
              "label": "버킷계수",
              "status": "match",
              "explain": "0.9",
              "file_value": 0.9,
              "variable_type": "condition_select",
              "condition_name": "약간 단단한 토질",
              "condition_value": 0.9
            },
            {
              "name": "f",
              "label": "체적변화율(1/L)",
              "status": "formula_derived",
              "explain": "0.9/1.24",
              "file_value": 0.73,
              "closest_value": 0.72,
              "variable_type": "condition_select",
              "condition_name": "점토 범위 조건",
              "formula_context": {
                "C": 0.9,
                "L": 1.24,
                "type": "C/L",
                "soil_found": true,
                "description": "다짐계수(0.9) / 토량변화율(1.24) — 점토 범위, 표준 범위 1.20~1.45",
                "formula_label": "다짐계수(0.9) / 토량변화율(1.24)",
                "short_description": "점토 범위 조건"
              },
              "closest_condition": "역 섞인 점질토(粘質土)"
            },
            {
              "name": "E",
              "label": "작업효율",
              "status": "no_value",
              "file_value": null,
              "variable_type": "condition_select"
            },
            {
              "name": "Cm",
              "label": "사이클타임",
              "status": "no_value",
              "file_value": null,
              "variable_type": "condition_select"
            }
          ]
        },
        {
          "machine_id": 183,
          "machine_name": "덤프트럭(자동덮개)",
          "subtitle_name": "운반 : 덤프트럭(자동덮개)",
          "template_name": "덤프트럭",
          "calc_method_ok": true,
          "overall_status": "match",
          "template_found": true,
          "variable_checks": [
            {
              "name": "rt",
              "label": "토사 비중(γt)",
              "status": "match",
              "explain": "1.6",
              "file_value": 1.6,
              "variable_type": "condition_select",
              "condition_name": "보통토(모래, 사질토, 마사토)",
              "condition_value": 1.6
            },
            {
              "name": "Lo",
              "label": "토량변화율(L)",
              "status": "in_range",
              "explain": "1.24",
              "file_value": 1.24,
              "closest_value": 1.25,
              "variable_type": "condition_select",
              "condition_name": "점토(粘土)",
              "closest_condition": "점토(粘土)"
            },
            {
              "name": "f",
              "label": "체적환산계수(f)",
              "status": "formula_derived",
              "explain": "0.9/1.24",
              "file_value": 0.73,
              "closest_value": 0.72,
              "variable_type": "condition_select",
              "condition_name": "점토(粘土) 범위 조건",
              "formula_context": {
                "C": 0.9,
                "L": 1.24,
                "type": "C/L",
                "soil_found": true,
                "description": "다짐계수(0.9) / 토량변화율(1.24) — 점토(粘土) 범위, 표준 범위 1.20~1.45",
                "formula_label": "다짐계수(0.9) / 토량변화율(1.24)",
                "short_description": "점토(粘土) 범위 조건"
              },
              "closest_condition": "역 섞인 점질토(粘質土)"
            },
            {
              "name": "E",
              "note": null,
              "label": "작업효율",
              "status": "user_input",
              "file_value": 0.9,
              "variable_type": "user_input"
            },
            {
              "name": "t1",
              "note": null,
              "label": "적재시간(t1)",
              "status": "user_input",
              "file_value": 11.19,
              "variable_type": "user_input"
            },
            {
              "name": "LD",
              "note": null,
              "label": "운반거리",
              "status": "user_input",
              "file_value": null,
              "variable_type": "user_input"
            },
            {
              "name": "V1",
              "label": "적재시 평균주행속도",
              "status": "match",
              "explain": "10",
              "file_value": 10.0,
              "variable_type": "condition_select",
              "condition_name": "교차 힘든 산간지/제방 도로",
              "condition_value": 10.0
            },
            {
              "name": "V2",
              "label": "공차시 평균주행속도",
              "status": "match",
              "explain": "15",
              "file_value": 15.0,
              "variable_type": "condition_select",
              "condition_name": "교차 힘든 산간지/제방 도로",
              "condition_value": 15.0
            },
            {
              "name": "t3",
              "label": "적하시간(t3)",
              "status": "match",
              "explain": "0.8",
              "file_value": 0.8,
              "variable_type": "condition_select",
              "condition_name": "모래·역·호박돌(보통)",
              "condition_value": 0.8
            },
            {
              "name": "t4",
              "label": "적재대기시간(t4)",
              "status": "match",
              "explain": "0.42",
              "file_value": 0.42,
              "variable_type": "condition_select",
              "condition_name": "좁으나 불편없이 진입 가능",
              "condition_value": 0.42
            },
            {
              "name": "t5",
              "label": "덮개 설치·해체시간(t5)",
              "status": "match",
              "explain": "0.5",
              "file_value": 0.5,
              "variable_type": "condition_select",
              "condition_name": "자동덮개시설의 경우",
              "condition_value": 0.5
            },
            {
              "name": "t6",
              "note": null,
              "label": "세륜기통과시간(t6)",
              "status": "user_input",
              "file_value": 1.5,
              "variable_type": "user_input"
            }
          ]
        }
      ]
    },
    {
      "id": 864,
      "name": "보조기층운반",
      "guide": "해당 변수값이 현장 조건에 적합한지 검토하세요.",
      "status": "modified",
      "changes": [],
      "severity": "high",
      "standard": "덤프트럭15톤",
      "description": "기계경비 변수가 조건표 범위를 벗어납니다.",
      "machine_checks": [
        {
          "machine_id": 183,
          "machine_name": "덤프트럭(자동덮개)",
          "subtitle_name": "덤프트럭(자동덮개)",
          "template_name": "덤프트럭",
          "calc_method_ok": true,
          "overall_status": "review_required",
          "template_found": true,
          "variable_checks": [
            {
              "name": "rt",
              "label": "토사 비중(γt)",
              "status": "match",
              "explain": "2",
              "file_value": 2.0,
              "variable_type": "condition_select",
              "condition_name": "잡석/석분/보조기층재",
              "condition_value": 2.0
            },
            {
              "name": "Lo",
              "label": "토량변화율(L)",
              "status": "no_value",
              "file_value": null,
              "variable_type": "condition_select"
            },
            {
              "name": "f",
              "label": "체적환산계수(f)",
              "status": "review_required",
              "explain": "1",
              "file_value": 1.0,
              "value_range": "0.54~0.88",
              "closest_value": 0.88,
              "variable_type": "condition_select",
              "closest_condition": "호박돌(玉石)"
            },
            {
              "name": "E",
              "note": null,
              "label": "작업효율",
              "status": "user_input",
              "file_value": 0.9,
              "variable_type": "user_input"
            },
            {
              "name": "t1",
              "note": null,
              "label": "적재시간(t1)",
              "status": "user_input",
              "file_value": 6.47,
              "variable_type": "user_input"
            },
            {
              "name": "LD",
              "note": null,
              "label": "운반거리",
              "status": "user_input",
              "file_value": null,
              "variable_type": "user_input"
            },
            {
              "name": "V1",
              "label": "적재시 평균주행속도",
              "status": "match",
              "explain": "30",
              "file_value": 30.0,
              "variable_type": "condition_select",
              "condition_name": "2차로 이상 공사용 도로",
              "condition_value": 30.0
            },
            {
              "name": "V2",
              "label": "공차시 평균주행속도",
              "status": "match",
              "explain": "35",
              "file_value": 35.0,
              "variable_type": "condition_select",
              "condition_name": "2차로 이상 공사용 도로",
              "condition_value": 35.0
            },
            {
              "name": "t3",
              "label": "적하시간(t3)",
              "status": "match",
              "explain": "0.8",
              "file_value": 0.8,
              "variable_type": "condition_select",
              "condition_name": "모래·역·호박돌(보통)",
              "condition_value": 0.8
            },
            {
              "name": "t4",
              "label": "적재대기시간(t4)",
              "status": "match",
              "explain": "0.42",
              "file_value": 0.42,
              "variable_type": "condition_select",
              "condition_name": "좁으나 불편없이 진입 가능",
              "condition_value": 0.42
            },
            {
              "name": "t5",
              "label": "덮개 설치·해체시간(t5)",
              "status": "match",
              "explain": "0.5",
              "file_value": 0.5,
              "variable_type": "condition_select",
              "condition_name": "자동덮개시설의 경우",
              "condition_value": 0.5
            },
            {
              "name": "t6",
              "note": null,
              "label": "세륜기통과시간(t6)",
              "status": "user_input",
              "file_value": 1.5,
              "variable_type": "user_input"
            }
          ]
        }
      ]
    }
  ],
  "government_materials": {
    "items": [
      {
        "name": "합성목재데크",
        "guide": "조달청 나라장터에서 최신 계약단가를 확인하세요.",
        "checks": [],
        "status": "price_mismatch",
        "db_name": "합성목재",
        "db_spec": "합성목재, 경동산업, KD-DS-25-p, 3000×150×25mm, 바닥재, 솔리드형",
        "category": "도급자관급",
        "db_price": 120000.0,
        "severity": "high",
        "standard": "3000×150×25mm",
        "work_name": "데크",
        "product_id": "23619045",
        "apply_price": 0.0,
        "description": "적용단가(0원)와 조달 계약단가(120,000원) 차이 120,000원",
        "contract_end": "20270321",
        "delivery_condition": "납품장소 하차도"
      },
      {
        "name": "옥외용벤치",
        "guide": "관급자관급으로 이동하세요.",
        "checks": [
          {
            "type": "분류 오류",
            "detail": "인도조건이 \"현장설치도\"이므로 관급자관급에 있어야 합니다.",
            "status": "error"
          }
        ],
        "status": "category_mismatch",
        "db_name": "옥외용벤치",
        "db_spec": "옥외용벤치, 한양에스티, HYB-105, 1600×450×450mm, 3인용",
        "category": "도급자관급",
        "db_price": 360000.0,
        "severity": "high",
        "standard": "1600×445×415mm",
        "work_name": "데크",
        "product_id": "26069492",
        "apply_price": 0.0,
        "description": "인도조건 \"현장설치도\" → 관급자관급이어야 하나 도급자관급에 배치됨",
        "contract_end": "20280331",
        "delivery_condition": "현장설치도"
      },
      {
        "name": "고정핀",
        "guide": "조달청 나라장터에서 해당 물품식별번호를 직접 조회하세요.",
        "checks": [],
        "status": "no_db_match",
        "db_name": null,
        "category": "도급자관급",
        "db_price": null,
        "severity": "medium",
        "standard": "Φ10×330mm",
        "work_name": "야자매트",
        "product_id": "12345678",
        "apply_price": 0.0,
        "description": "물품식별번호 12345678에 해당하는 조달단가가 없습니다.",
        "contract_end": null,
        "delivery_condition": ""
      },
      {
        "name": "보행매트",
        "guide": "조달청 나라장터에서 최신 계약단가를 확인하세요.",
        "checks": [],
        "status": "price_mismatch",
        "db_name": "매트형유흡착재",
        "db_spec": "매트형유흡착재, 오성엔에이치, NH-M10 1매, 500×500mm",
        "category": "도급자관급",
        "db_price": 1150.0,
        "severity": "high",
        "standard": "1000×t30mm",
        "work_name": "야자매트",
        "product_id": "24477867",
        "apply_price": 0.0,
        "description": "적용단가(0원)와 조달 계약단가(1,150원) 차이 1,150원",
        "contract_end": "20290131",
        "delivery_condition": "납품장소 하차도"
      },
      {
        "name": "스텐레스볼라드",
        "guide": "자재단가의 조달단가 정보 또는 비고란에서 물품식별번호를 확인하세요.",
        "checks": [],
        "status": "no_product_id",
        "db_name": null,
        "category": "도급자관급",
        "db_price": null,
        "severity": "medium",
        "standard": "SUS304, H=1000",
        "work_name": "엣지케이스",
        "product_id": null,
        "apply_price": 250000.0,
        "description": "비고란에 물품식별번호(8자리)를 확인하세요.",
        "contract_end": null,
        "delivery_condition": ""
      },
      {
        "name": "안전표지판",
        "guide": "자재단가의 조달단가 정보 또는 비고란에서 물품식별번호를 확인하세요.",
        "checks": [],
        "status": "no_product_id",
        "db_name": null,
        "category": "도급자관급",
        "db_price": null,
        "severity": "medium",
        "standard": "600x900, 반사형",
        "work_name": "엣지케이스",
        "product_id": null,
        "apply_price": 45000.0,
        "description": "비고란에 물품식별번호(8자리)를 확인하세요.",
        "contract_end": null,
        "delivery_condition": ""
      },
      {
        "name": "탄성포장재",
        "guide": "추가 확인이 필요하지 않습니다.",
        "checks": [],
        "status": "pass",
        "db_name": "합성목재",
        "db_spec": "합성목재, 경동산업, KD-DS-25-p, 3000×150×25mm, 바닥재, 솔리드형",
        "category": "도급자관급",
        "db_price": 120000.0,
        "severity": "none",
        "standard": "EPDM, t=13mm",
        "work_name": "엣지케이스",
        "product_id": "23619045",
        "apply_price": 120000.0,
        "description": "조달청 계약단가와 일치합니다.",
        "contract_end": "20270321",
        "delivery_condition": "납품장소 하차도"
      },
      {
        "name": "조경석",
        "guide": "관급자관급으로 이동하세요.",
        "checks": [
          {
            "type": "분류 오류",
            "detail": "인도조건이 \"현장설치도\"이므로 관급자관급에 있어야 합니다.",
            "status": "error"
          }
        ],
        "status": "category_mismatch",
        "db_name": "옥외용벤치",
        "db_spec": "옥외용벤치, 한양에스티, HYB-105, 1600×450×450mm, 3인용",
        "category": "도급자관급",
        "db_price": 360000.0,
        "severity": "high",
        "standard": "자연석, 0.5ton",
        "work_name": "엣지케이스",
        "product_id": "26069492",
        "apply_price": 85000.0,
        "description": "인도조건 \"현장설치도\" → 관급자관급이어야 하나 도급자관급에 배치됨",
        "contract_end": "20280331",
        "delivery_condition": "현장설치도"
      },
      {
        "name": "무가재료",
        "guide": "조달청 나라장터에서 최신 계약단가를 확인하세요.",
        "checks": [],
        "status": "price_mismatch",
        "db_name": "매트형유흡착재",
        "db_spec": "매트형유흡착재, 오성엔에이치, NH-M10 1매, 500×500mm",
        "category": "도급자관급",
        "db_price": 1150.0,
        "severity": "high",
        "standard": "시험용",
        "work_name": "엣지케이스",
        "product_id": "24477867",
        "apply_price": 0.0,
        "description": "적용단가(0원)와 조달 계약단가(1,150원) 차이 1,150원",
        "contract_end": "20290131",
        "delivery_condition": "납품장소 하차도"
      },
      {
        "name": "특수자재A",
        "guide": "자재단가의 조달단가 정보 또는 비고란에서 물품식별번호를 확인하세요.",
        "checks": [],
        "status": "no_product_id",
        "db_name": null,
        "category": "도급자관급",
        "db_price": null,
        "severity": "medium",
        "standard": "",
        "work_name": "엣지케이스",
        "product_id": null,
        "apply_price": 500000.0,
        "description": "비고란에 물품식별번호(8자리)를 확인하세요.",
        "contract_end": null,
        "delivery_condition": ""
      },
      {
        "name": "합성목재데크",
        "guide": "도급자관급으로 이동하세요.",
        "checks": [
          {
            "type": "분류 오류",
            "detail": "인도조건이 \"납품장소 하차도\"이므로 도급자관급에 있어야 합니다.",
            "status": "error"
          }
        ],
        "status": "category_mismatch",
        "db_name": "합성목재",
        "db_spec": "합성목재, 경동산업, KD-DS-25-p, 3000×150×25mm, 바닥재, 솔리드형",
        "category": "관급자관급",
        "db_price": 120000.0,
        "severity": "high",
        "standard": "3000×150×25mm",
        "work_name": "데크",
        "product_id": "23619045",
        "apply_price": 0.0,
        "description": "인도조건 \"납품장소 하차도\" → 도급자관급이어야 하나 관급자관급에 배치됨",
        "contract_end": "20270321",
        "delivery_condition": "납품장소 하차도"
      },
      {
        "name": "보행매트",
        "guide": "도급자관급으로 이동하세요.",
        "checks": [
          {
            "type": "분류 오류",
            "detail": "인도조건이 \"납품장소 하차도\"이므로 도급자관급에 있어야 합니다.",
            "status": "error"
          }
        ],
        "status": "category_mismatch",
        "db_name": "매트형유흡착재",
        "db_spec": "매트형유흡착재, 오성엔에이치, NH-M10 1매, 500×500mm",
        "category": "관급자관급",
        "db_price": 1150.0,
        "severity": "high",
        "standard": "W=1200",
        "work_name": "분류오류테스트",
        "product_id": "24477867",
        "apply_price": 23000.0,
        "description": "인도조건 \"납품장소 하차도\" → 도급자관급이어야 하나 관급자관급에 배치됨",
        "contract_end": "20290131",
        "delivery_condition": "납품장소 하차도"
      }
    ],
    "summary": {
      "pass": 1,
      "total": 12,
      "issues": 11,
      "do_count": 10,
      "guan_count": 2
    }
  },
  "labor_prices_summary": {
    "pass": 0,
    "total": 9,
    "modified": 0,
    "needs_review": 9
  },
  "itemize_costs_summary": {
    "pass": 31,
    "total": 38,
    "modified": 0,
    "needs_review": 7
  },
  "material_prices_summary": {
    "pass": 4,
    "total": 28,
    "modified": 0,
    "needs_review": 24
  },
  "price_calculations_summary": {
    "pass": 3,
    "total": 5,
    "modified": 2,
    "needs_review": 0
  }
};
